<div class="assistente-virtual-container">
  <!-- Menu de atalhos -->
  <div class="atalhos-menu" [class.aberto]="menuAberto">
    <div class="atalhos-lista">
      <!-- Atalhos por categoria -->
      <div *ngFor="let categoria of getCategorias()" class="categoria-grupo">
        <div class="categoria-header" *ngIf="getAtalhosPorCategoria(categoria).length > 0">
          {{ getNomeCategoria(categoria) }}
        </div>
        <button
          *ngFor="let atalho of getAtalhosPorCategoria(categoria)"
          class="atalho-item"
          (click)="navegarPara(atalho.rota)"
          type="button">
          <nb-icon [icon]="atalho.icone"></nb-icon>
          <span>{{ atalho.titulo }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Botão flutuante principal -->
  <button
    class="botao-assistente"
    (click)="toggleMenu()"
    type="button"
    [attr.aria-label]="menuAberto ? 'Fechar menu' : 'Abrir assistente virtual'"
    title="Assistente Virtual">
    <nb-icon [icon]="menuAberto ? 'close-outline' : 'flash-outline'"></nb-icon>
  </button>
</div>
